import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from '../../../styles/style-utils';

const Grid = styled.div`
  > div:not(:last-child) {
    margin-bottom: 3rem;
  }

  ${media.mediumLarge`
    display: grid;
    grid-template-columns: repeat(${props => (props.numberOfColumns > 2 ? 2 : props.numberOfColumns)}, 1fr);
    grid-gap: 3rem;

    > div:not(:last-child) {
      margin-bottom: 0;
    }
  `}

  ${media.large`
    grid-template-columns: repeat(${props => (props.numberOfColumns > 3 ? 3 : props.numberOfColumns)}, 1fr);
  `}

  ${media.extraLarge`
    grid-template-columns: repeat(${props => props.numberOfColumns}, 1fr);
  `}
`;

const MultiColumnsGrid = props => {
  const { numberOfColumns, children } = props;
  return <Grid numberOfColumns={numberOfColumns}>{children}</Grid>;
};

MultiColumnsGrid.propTypes = {
  numberOfColumns: PropTypes.number,
  children: PropTypes.node,
};

export default MultiColumnsGrid;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/gridBlock/MultiColumnsGrid.js